(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-slider')) {
    class TtSlider extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.index = 0;
        if (!this.track || this.slides.length < 2) return;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1), { signal });
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot)), { signal }));
        this.addEventListener('mouseenter', () => this.stop(), { signal });
        this.addEventListener('mouseleave', () => this.start(), { signal });
        this.addEventListener('focusin', () => this.stop(), { signal });
        this.addEventListener('focusout', () => this.start(), { signal });

        /* Swipe: follow the finger, then snap to the nearest slide */
        let startX = 0;
        let startY = 0;
        let dx = 0;
        let dragging = false;
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          dragging = true;
          startX = event.clientX;
          startY = event.clientY;
          dx = 0;
          this.stop();
        }, { signal });
        this.track.addEventListener('pointermove', (event) => {
          if (!dragging) return;
          dx = event.clientX - startX;
          if (Math.abs(dx) < Math.abs(event.clientY - startY)) return;
          this.track.classList.add('is-dragging');
          this.track.style.transform = `translate3d(calc(${this.index * -100}% + ${dx}px), 0, 0)`;
        }, { signal });
        const end = () => {
          if (!dragging) return;
          dragging = false;
          this.track.classList.remove('is-dragging');
          this.track.style.transform = '';
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          this.start();
        };
        this.track.addEventListener('pointerup', end, { signal });
        this.track.addEventListener('pointercancel', end, { signal });
        this.track.addEventListener('click', (event) => {
          if (Math.abs(dx) > 10) event.preventDefault();
        }, { signal, capture: true });

        this.start();
      }

      disconnectedCallback() {
        this.stop();
        this.abort?.abort();
      }

      go(i) {
        const count = this.slides.length;
        this.index = (i + count) % count;
        this.track.style.setProperty('--tt-index', String(this.index));
        this.slides.forEach((slide, n) => slide.setAttribute('aria-hidden', String(n !== this.index)));
        this.dots.forEach((dot, n) => dot.setAttribute('aria-selected', String(n === this.index)));
      }

      start() {
        const ms = Number(this.dataset.autoplay);
        if (!ms || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), ms);
      }

      stop() {
        clearInterval(this.timer);
      }
    }
    customElements.define('tt-slider', TtSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tt-scroller')) {
    class TtScroller extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        const row = this.querySelector('[data-row]');
        if (!row) return;
        const step = () => Math.max(row.clientWidth * 0.8, 280);
        this.querySelector('[data-prev]')?.addEventListener('click', () => row.scrollBy({ left: -step() }), { signal });
        this.querySelector('[data-next]')?.addEventListener('click', () => row.scrollBy({ left: step() }), { signal });

        const markClamped = () => {
          for (const quote of this.querySelectorAll('[data-quote]')) {
            const card = quote.closest('.tt-tm-card');
            const more = card?.querySelector('[data-more]');
            if (!more || card.classList.contains('is-open')) continue;
            more.hidden = quote.scrollHeight <= quote.clientHeight + 2;
          }
        };
        markClamped();
        window.addEventListener('resize', markClamped, { signal });

        this.addEventListener(
          'click',
          (event) => {
            const more = event.target.closest('[data-more]');
            if (!more) return;
            const open = more.closest('.tt-tm-card').classList.toggle('is-open');
            more.setAttribute('aria-expanded', String(open));
            more.textContent = open ? 'Daha az göster' : 'Devamını oku';
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.abort?.abort();
      }
    }
    customElements.define('tt-scroller', TtScroller);
  }

  } catch(e) { console.error(e); }
})();
})();
